import React from 'react';

import { Button, Group, Modal, Stack, Text } from '@mantine/core';

interface AddToInvoiceSuccessModalProps {
  opened: boolean;
  onClose: () => void;
  productTypeModule: string;
  onGoToInvoice: () => void;
}

const formatProductTypeModule = (module: string): string => {
  switch (module) {
    case 'retail':
      return 'Retail';
    case 'fees-and-misc':
      return 'Fees and Miscellaneous';
    default:
      return module;
  }
};

const AddToInvoiceSuccessModal = ({
  opened,
  onClose,
  productTypeModule,
  onGoToInvoice,
}: AddToInvoiceSuccessModalProps): JSX.Element => {
  const formattedProductType = formatProductTypeModule(productTypeModule);

  return (
    <Modal opened={opened} onClose={onClose} trapFocus centered size='md'>
      <Stack px='md' w='100%' align='center'>
        <Text fw={500} align='center'>
          {formattedProductType} Items Successfully Added to the Invoice
        </Text>
        <Text align='center' color='dimmed'>
          Would you like to see the invoice?
        </Text>
      </Stack>
      <Group position='center' py='md'>
        <Button onClick={onGoToInvoice}>See Invoice</Button>
      </Group>
    </Modal>
  );
};

export default AddToInvoiceSuccessModal;
